<template>
    <v-row align="center">
        <v-col>
            <v-select v-model="form.gender.value" :items="genders" outlined attach @input="emit" />
        </v-col>
        <v-col cols="auto">
            <v-switch v-model="form.gender.isIrrelevant" label="성별무관" dense inset hide-details @input="emit" />
        </v-col>
        <v-col cols="12" class="pa-0 pb-12">
            <discrimination-dialog-sex>
                <template #activator="{ attrs, on }">
                    <v-btn small text color="primary" v-bind="attrs" v-on="on"> ※ 성차별금지 남녀고용평등에 관한 법률 </v-btn>
                </template>
            </discrimination-dialog-sex>
        </v-col>
    </v-row>
</template>

<script>
import { GENDERS, initRecruitmentField__qualification } from "@/assets/variables";

import DiscriminationDialogSex from "./discrimination-dialog-sex.vue";

const genders = Object.values(GENDERS);

export default {
    components: {
        DiscriminationDialogSex,
    },
    props: {
        value: { type: Object, default: initRecruitmentField__qualification },
    },
    data: () => ({
        form: initRecruitmentField__qualification(),
        genders,
    }),
    mounted() {
        this.sync();
    },
    watch: {
        value() {
            this.sync();
        },
    },
    methods: {
        sync() {
            this.form = initRecruitmentField__qualification(this.value);
        },
        emit() {
            this.$emit("input", this.form);
        },
    },
};
</script>

<style>
</style>